export const mobileWidht = 900;
export const mobileBreakpoint = `max-width: ${mobileWidht}px`;
